import { SurveyQueueResponseData } from '@modules/HappinessModule/api/surveyQueue';
import { SurveyCategory, SurveyQuestion, SurveyQueue } from './interfaces';

interface PositionedCategory {
  id: string;
  name: string;
  isActive: boolean;
  questions: Array<SurveyQuestion & { position: number }>;
}

export const mapResponseDataToSurveyQueue = (responseData: SurveyQueueResponseData): SurveyQueue => {
  const categoriesByGroupPosition = new Map<number, PositionedCategory>();

  responseData.queue.forEach(
    ({ question: { question_group, id: question_id, text }, group_position, question_position, is_active }) => {
      let category = categoriesByGroupPosition.get(group_position);
      if (!category) {
        category = { id: question_group.id, name: question_group.name, isActive: is_active, questions: [] };
        categoriesByGroupPosition.set(group_position, category);
      }
      category.questions.push({ id: question_id, text, position: question_position });
    }
  );

  const categories: SurveyCategory[] = Array.from(categoriesByGroupPosition.entries())
    .sort(([groupPositionA], [groupPositionB]) => groupPositionA - groupPositionB)
    .map(([, category]) => ({
      id: category.id,
      name: category.name,
      isActive: category.isActive,
      questions: category.questions.sort((a, b) => a.position - b.position).map(({ id, text }) => ({ id, text })),
    }));

  return {
    categories,
    lastSurvey: responseData.last_survey
      ? {
          date: responseData.last_survey.date,
          categoryName: responseData.last_survey.category_name,
          questionText: responseData.last_survey.question_text,
        }
      : undefined,
  };
};
